import { createContext } from "react";

import { OrderValue } from "./types";

export const OrderContext = createContext<OrderValue | undefined>(undefined);
